/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import routes from "routes.js";

class Auth extends React.Component {
  componentDidMount() {
    //document.body.classList.add("bg-default");
  }
  componentWillUnmount() {
    //document.body.classList.remove("bg-default");
  }
  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <>
        <div className="main-content main-content-login">
          {/* <AuthNavbar /> */}
          <div className="header bg-gradient-login py-7 py-lg-8">
          <div style={styles.wyvernContainer}>
          <img src={require('../assets/img/wyvern.svg')} style={styles.wyvern} />
        </div>
            <div className="separator separator-bottom separator-skew zindex-100">
         
            </div>
          </div>
          {/* Page content */}
          <Container className="mt--8 pb-5">
            <Row className="justify-content-center">
              <Switch>
                {this.getRoutes(routes)}
                <Redirect from="*" to="/auth/login" />
              </Switch>
            </Row>
          </Container>
  
        </div>
      </>
    );
  }
}


const styles ={
  wyvernContainer: {
      position: 'absolute',
      zIndex: -10,
      left: -300,
      top: 0,
      width: '100%'

  },
  wyvern: {
    opacity: 0.2,
    width: 700,
    position: 'absolute',
    left: '80%',
    top:'60%'
  }
}
export default Auth;
